import { KeyRound, Lock, ShieldCheck } from 'lucide-react'

export const authSchemeConfig = {
  OAUTH2: {
    icon: Lock,
    gradient: 'from-blue-50 to-indigo-50',
    text: 'text-indigo-700',
    border: 'border-indigo-100',
    hoverGradient: 'hover:from-blue-100 hover:to-indigo-100',
  },
  API_KEY: {
    icon: KeyRound,
    gradient: 'from-emerald-50 to-green-50',
    text: 'text-emerald-700',
    border: 'border-emerald-100',
    hoverGradient: 'hover:from-emerald-100 hover:to-green-100',
  },
  NO_AUTH: {
    icon: ShieldCheck,
    gradient: 'from-amber-50 to-yellow-50',
    text: 'text-amber-700',
    border: 'border-amber-100',
    hoverGradient: 'hover:from-amber-100 hover:to-yellow-100',
  },
  BASIC: {
    icon: ShieldCheck,
    gradient: 'from-amber-50 to-yellow-50',
    text: 'text-amber-700',
    border: 'border-amber-100',
    hoverGradient: 'hover:from-amber-100 hover:to-yellow-100',
  },
  BEARER_TOKEN: {
    icon: Lock,
    gradient: 'from-purple-50 to-fuchsia-50',
    text: 'text-purple-700',
    border: 'border-purple-100',
    hoverGradient: 'hover:from-purple-100 hover:to-fuchsia-100',
  },
  OAUTH1: {
    icon: KeyRound, // Using KeyRound as a unique icon since it's not used for other auth types
    gradient: 'from-rose-50 to-pink-50',
    text: 'text-rose-700',
    border: 'border-rose-100',
    hoverGradient: 'hover:from-rose-100 hover:to-pink-100',
  },
  CUSTOM: {
    icon: ShieldCheck,
    gradient: 'from-sky-50 to-cyan-50',
    text: 'text-sky-700',
    border: 'border-sky-100',
    hoverGradient: 'hover:from-sky-100 hover:to-cyan-100',
  },
} as const
